import { FormFieldDataAvailability, FormFieldDateInput, FormFieldRadio, FormFieldTextInput } from '@publishing-engine/domain/types/article';
import { useFormContext } from 'react-hook-form';
import DataAvailabilityFormItem, {
  IDataAvailabilityForm
} from 'src/components/Submission/DataAvailability/FormItem';

const DataAvailability = ({
  config,
  DataAvailabilityOpenlyAvailableUrlConfig,
  DataAvailabilityEmbargoUrlConfig,
  DataAvailabilityEmbargoDateConfig,
  DataUnavailabilityReasonConfig

}: {
  config: FormFieldDataAvailability;
  DataAvailabilityOpenlyAvailableUrlConfig?: FormFieldTextInput<'preference.dataAvailabilityOpenlyAvailableUrl'>;
  DataAvailabilityEmbargoUrlConfig?: FormFieldTextInput<'preference.dataAvailabilityEmbargoUrl'>;
  DataAvailabilityEmbargoDateConfig?: FormFieldDateInput<'preference.dataAvailabilityEmbargoDate'>;
  DataUnavailabilityReasonConfig?: FormFieldRadio<'preference.dataUnavailabilityReason'>;

}) => {
  const {
    formState: { errors },
    watch,
    control
  } = useFormContext<IDataAvailabilityForm>();

  return (
    <DataAvailabilityFormItem
      config={config}
      errors={errors}
      watch={watch}
      control={control}
      DataAvailabilityOpenlyAvailableUrlConfig={DataAvailabilityOpenlyAvailableUrlConfig}
      DataAvailabilityEmbargoUrlConfig={DataAvailabilityEmbargoUrlConfig}
      DataAvailabilityEmbargoDateConfig={DataAvailabilityEmbargoDateConfig}
      DataUnavailabilityReasonConfig={DataUnavailabilityReasonConfig}

    />
  );
};

export default DataAvailability;
